import { useMutation } from 'react-query';
import { queryClient } from '../../../../../../../../config/queryClient';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../../../../../CommonUtils/urlWithParams';
import {
  AnnualBenefitsSummaryDTO,
  SocialSecurityStrategy,
  Params as AnnualBenefitsQueryParams,
} from './useAnnualBenefitsSummaryQuery';
import { SocialSecurityWhatIf } from './types';
import { queryKeys } from './queryKeys';

export interface Params {
  clientId: number;
  fpId: string;
  strategy: SocialSecurityStrategy;
  body: SocialSecurityWhatIf[];
  signal?: AbortSignal;
}

export const fetchAnnualBenefitsSummaryWithWhatIfs = ({
  clientId,
  fpId,
  strategy,
  body,
  signal,
}: Params): Promise<AnnualBenefitsSummaryDTO> => {
  return authFetch(
    urlWithParams('/Consumer/OptimizeSocialSecurity/GetAnnualBenefitsSummaryWithWhatIfs', {
      clientId,
      fpId,
      strategy,
    }),
    {
      method: 'POST',
      ...httpBodyOptions(body, true),
      signal,
    },
  );
};

export const useAnnualBenefitsSummaryWithWhatIfsMutation = ({ clientId, fpId, strategy }: Omit<AnnualBenefitsQueryParams, 'enabled'>) => {
  return useMutation(fetchAnnualBenefitsSummaryWithWhatIfs, {
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.annualBenefitsSummary(clientId, fpId, strategy));
    },
  });
};
